export function confirmation() {
  const wpcf7Elm = document.querySelectorAll(".wpcf7");
  // const wpcf7Elm = $(".wpcf7");
  // if(wpcf7Elm) {
  //   wpcf7Elm.forEach((elem) => {
  //     item.on("wpcf7mailsent", (event) => {
  //       $(".popup-scheduling-request").removeClass("opened");
  //       $(".popups").addClass("active"); 
  //       $(".popup-confirmation").addClass("opened");
  //   });
  // }
  if (wpcf7Elm) {
    [...wpcf7Elm].map((item) => {
      item.addEventListener("wpcf7mailsent", function (event) {
        document.querySelector(".popup-scheduling-request").classList.remove("opened");
        document.querySelector(".popups").classList.add("active"); 
        document.querySelector(".popup-confirmation").classList.add("opened");
      }, false);
    });
  }
}


// WEBPACK FOOTER //
// ./assets/js/modules/confirmation.js